import { ModelRuleChangeModelRule } from '@Models';
import { model_rule_change_model_rule_full } from '@Api';
import { injectable } from 'inversify';

@injectable()
export class ModelRuleChangeModelRuleMapper {
  map(item: model_rule_change_model_rule_full): ModelRuleChangeModelRule {
    return {};
  }
}
